import Link from 'next/link';
import ChevronLeftIcon from '../icons/ChevronLeftIcon';

const BackButton: React.FC = () => (
  <Link href="/trainers/">
    <button className="p-2 text-neutral-0 transition duration-300 ease-in-out hover:text-azure-500">
      <ChevronLeftIcon className="size-6" />
    </button>
  </Link>
);

export default BackButton;
